'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.login',
dependencies:['ui.router'],
configs:[
require('./loginConfig')],

components:[
require('./loginController'),
require('./modals/loginModalController')]});
//# sourceMappingURL=index.js.map
